import { Color } from './color';
/**
 * ●
 */
export const Point = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'point' }, options), context);
};
Point.props = Object.assign({ defaultMarker: 'point' }, Color.props);
//# sourceMappingURL=point.js.map